// 3_pages/product_detail.js
// Product detail page (body.type-product): rebuilds the product-top layout
// (name, brand/code, stars, parameters, availability, add-to-cart, sticky sell
// bar), Natios brand blocks, price-per-unit from measure filters, custom tab
// navigation, main-image carousel, ratings controls, analysis-table
// explanations, glossary tooltips and the delivery-prices popup fix.

import {
	bindDeliveryTooltipInteractions,
	disableBootstrapDeliveryTooltips,
	enhanceDeliveryTooltips,
} from "../2_components/delivery_tooltip.js";
import { enhanceQuantityDiscounts } from "../2_components/quantity_discounts.js";
import { applyGlossary } from "../2_components/slovnik_pojmu.js";
import { initProductSets } from "../2_components/product_sets.js";

const body = document.body;

// Shared state used across the product-detail functions (was a block of
// top-level `let`s in the old monolith).
let isNatiosProduct;
let isAvailableProduct;
let infoWrapper;
let productName;
let productCode;
let productCodeValue;
let productBrand;
let starsWrapper;
let tabContent;
let extendedDescription;
let detailParameters;
let shortDescription;
let longDescription;
let dostupnost;
let shippingOptions;
let addToCartBtn;
let priceWrapper;
let finalProductPrice;
let continueReadingShortDescription;
let souvisejiciProdukty;
let souvisejiciProduktyTitle;
let benefitBanner;
let productsAlternative;
let watchdog;
let relatedFiles;
let ratingTab;
let productVotesWraps;
let loadNextRatings;
// NOTE: assigned without any declaration in the old code (implicit global);
// declared here because ES modules run in strict mode.
let parametersInProductTopTrs;

export function init() {
	if (!body.classList.contains("type-product")) return;

	const missingUtil = [
		"scrollToElement",
		"inicializeSliderElement",
		"inicializeSliderElementSnap",
		"downloadAndSaveMeasureUnitFilter",
	].find(function (name) {
		return !window.NAT?.utils?.[name];
	});
	if (missingUtil) {
		console.warn("[NAT] product_detail.js: window.NAT.utils." + missingUtil + " missing — check load order");
		return;
	}

	isNatiosProduct = false;
	isAvailableProduct = false;

	infoWrapper = document.querySelector(".product-top .p-info-wrapper");
	productName = document.querySelector(".p-detail-inner-header h1");
	productCode = document.querySelector(".p-detail-inner-header .p-code");
	productCodeValue = "";

	productBrand = document.querySelector(".product-top a[data-testid='productCardBrandName']");
	starsWrapper = document.querySelector(".product-top .stars-wrapper");

	tabContent = document.querySelector("#tab-content");
	extendedDescription = document.querySelector("#description .extended-description");
	detailParameters = document.querySelector(".description-inner .detail-parameters");
	shortDescription = document.querySelector(".p-short-description");
	longDescription = document.querySelector("#description");

	dostupnost = document.querySelector(".product-top .availability-value");
	shippingOptions = document.querySelector(".product-top .shipping-options")?.closest("table") || null;

	addToCartBtn = document.querySelector(".product-top .add-to-cart");
	priceWrapper = document.querySelector(".product-top .p-final-price-wrapper");

	finalProductPrice = document.querySelector(".product-top .price-final");

	continueReadingShortDescription = document.querySelector(".product-top p[data-testid='productCardDescr']");

	souvisejiciProdukty = document.querySelector(".products-block.products-related");
	souvisejiciProduktyTitle = document.querySelector(".products-related-header");

	benefitBanner = document.querySelector(".benefitBanner");

	productsAlternative = document.querySelector("#productsAlternative");
	watchdog = document.querySelector(".product-top .watchdog");
	relatedFiles = document.querySelector("#relatedFiles");
	ratingTab = document.querySelector("#ratingTab");
	productVotesWraps = document.querySelectorAll("#ratingsList .vote-wrap");
	loadNextRatings =
		document.querySelector("#ratingTab .load-next-wrap") || document.querySelector("#ratingTab .listingControls");

	moveElementsInProduct();

	const bootProductDetailUi = async () => {
		await initProductSets();
		productThumbnailInNavigation();
		productNavigationCustom();
		makeCarouselFromImages();
		disableBootstrapDeliveryTooltips();
	};

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", bootProductDetailUi);
	} else {
		bootProductDetailUi();
	}

	addLaboratoryAnalysisToTop();
	analysisTableExplanation();

	if ($(".nelze-uplatnit-slevovy-kod, .nelze-uplatnit-slevovy-kupon").length > 0) {
		$(".nelze-uplatnit-slevovy-kod, .nelze-uplatnit-slevovy-kupon").html(
			"<p>" + window.NAT.translations("noSaleCoupon") + "</p>"
		);
	}
	if ($(".nelze-uplatnit-vernostni-slevu").length > 0) {
		$(".nelze-uplatnit-vernostni-slevu").html("<p>" + window.NAT.translations("noLoyaltySale") + "</p>");
	}

	addDenDetiTextToShortDescription();

	document.addEventListener("DOMContentLoaded", function () {
		const thumbnailsWrapper = document.querySelector(".p-thumbnails-inner");
		const thumbnailsParent = document.querySelector(".p-thumbnails-inner > div");
		const thumbnails = document.querySelectorAll(".p-thumbnail");
		if (thumbnails && thumbnailsParent && thumbnailsWrapper) {
			window.NAT.utils.inicializeSliderElement(thumbnailsWrapper, thumbnailsParent, thumbnails, "thumbnails-slider", null);
		}
		inicializeReviewFromEmail();
	});

	/* Delivery options popup */
	editDeliveryPricesPopup();

	applyGlossary("#description");
}

function moveElementsInProduct() {
	if (!infoWrapper) {
		console.warn("Info wrapper not found.");
		return; // Exit if any of the elements are not found
	}

	if (!window.NAT.media.isMobile) {
		if (productName) {
			infoWrapper.prepend(productName);
		}
	}

	const rightContentWrapper = document.createElement("div");
	rightContentWrapper.className = "right-content-wrapper";

	const shortBenefitsWrapper = document.createElement("div");
	shortBenefitsWrapper.className = "short-benefits-wrapper";

	const vhodneProWrapper = document.createElement("div");
	vhodneProWrapper.className = "vhodne-pro-wrapper";

	const manufacturerAndCodeWrapper = document.createElement("div");
	manufacturerAndCodeWrapper.className = "manufacturer-and-code-wrapper";

	rightContentWrapper.appendChild(shortBenefitsWrapper);
	rightContentWrapper.appendChild(vhodneProWrapper);
	rightContentWrapper.appendChild(manufacturerAndCodeWrapper);
	infoWrapper.appendChild(rightContentWrapper);

	if (shortDescription) {
		const shortDescriptionFirstUl = shortDescription.querySelector("ul");
		if (shortDescriptionFirstUl) {
			shortBenefitsWrapper.appendChild(shortDescriptionFirstUl);
			shortBenefitsWrapper.classList.add("active");
		}
	}

	if (productBrand || document.querySelector(".product-widgets[product-template='natios']")) {
		if (productBrand) {
			manufacturerAndCodeWrapper.appendChild(productBrand);
			manufacturerAndCodeWrapper.classList.add("active");
		}

		if (
			document.querySelector(".product-widgets[product-template='natios']") ||
			(productBrand && productBrand.textContent && productBrand.textContent.toLowerCase().includes("natios"))
		) {
			if (productBrand && productBrand.textContent && productBrand.textContent.toLowerCase().includes("natios")) {
				isNatiosProduct = true;
			}

			body.classList.add("product-is-natios");

			if (isNatiosProduct) {
				productBrand.setAttribute("href", "/natios");
			}

			if (window.NAT.lang === "cs" || window.NAT.lang === "sk") {
				if (isNatiosProduct) {
					productBrand.classList.add("natios");

					const natiosBrandBlock = document.createElement("div");
					natiosBrandBlock.className = "natios-brand-description-block-wrapper";

					const natiosLargeBrandBlock = document.createElement("div");
					natiosLargeBrandBlock.className = "natios-support-wrapper";
					if (window.NAT.lang === "pl") {
						// NOTE: unreachable — this branch only runs when lang is "cs" or "sk" (outer check); preserved from old code.
						return;
					}

					natiosBrandBlock.innerHTML =
						'<div id="natios-brand-description-block"><div class="natios-brand-description-block-logo"><img src="https://cdn.myshoptet.com/usr/www.natima.cz/user/documents/upload/assets/icon_logo_natios_no_bg.svg" width="140px" height="auto" alt="Natios Logo"></div><div class="natios-brand-description-block-text"><p>' +
						window.NAT.translations("natiosDescription") +
						'<a href="/natios/">' +
						window.NAT.translations("more") +
						'</a></p></div><div class="natios-brand-description-block-donation"><div class="natios-brand-description-block-donation-icon"><img src="https://cdn.myshoptet.com/usr/www.natima.cz/user/documents/upload/assets/icon_natios_donate.svg" width="47px" height="auto" alt="Charity"></div><p>' +
						window.NAT.translations("natiosSupportTextTop") +
						'<span class="scroll-to-FNO">' +
						window.NAT.translations("more") +
						"</span></p></div></div>";
					if (benefitBanner) {
						benefitBanner.classList.add("natios-block-added");
					}
					natiosLargeBrandBlock.innerHTML =
						'<div class="natios-support-icon"><img src="https://cdn.myshoptet.com/usr/www.natima.cz/user/documents/upload/NatiosDarujeFNO_2.svg" alt="Natios Charity" width="174" height="174"></div><div class="natios-support-wrapper-content"><div class="natios-support-wrapper-content-title">' +
						window.NAT.translations("natiosSupportHeaderBottom") +
						" </div><p>" +
						window.NAT.translations("natiosSupportTextBottom") +
						"</p><p>" +
						window.NAT.translations("natiosSupportTotalAmount") +
						'</p><p><a href="' +
						window.NAT.translations("natiosSupportBlogUrl") +
						'">' +
						window.NAT.translations("moreAboutSupport") +
						"</a></p></div>";
					if (tabContent) {
						tabContent.appendChild(natiosLargeBrandBlock);
					}

					document.querySelector(".product-top").insertAdjacentElement("afterend", natiosBrandBlock);
					document.querySelector(".scroll-to-FNO").addEventListener("click", function () {
						window.NAT.utils.scrollToElement(natiosLargeBrandBlock);
					});
				}
			}
		}
	}

	if (productCode) {
		manufacturerAndCodeWrapper.appendChild(productCode);
		manufacturerAndCodeWrapper.classList.add("active");
		productCodeValue = productCode.querySelector("span:not(.p-code-label)").textContent.trim();
	}

	if (starsWrapper) {
		if (!window.NAT.media.isMobile) {
			infoWrapper.appendChild(starsWrapper);
		} else {
			if (productName) {
				productName.parentElement.appendChild(starsWrapper);
			}
		}
		const starsElement = starsWrapper.querySelector(".star");

		if (starsElement) {
			let starsScore = starsElement.getAttribute("title") || starsElement.getAttribute("data-original-title");

			if (starsScore) {
				starsScore = starsScore.split(":")[1].split("/")[0].trim();
				starsScore = parseFloat(starsScore).toFixed(2).replace(".", ",");
				if (starsScore != null && starsScore != "NaN") {
					const starsScoreElement = document.createElement("div");
					starsScoreElement.className = "stars-score";
					starsScoreElement.innerHTML = `<span class="stars-score-text">${starsScore}</span> / 5`;
					starsWrapper.appendChild(starsScoreElement);
				} else {
					starsWrapper.classList.add("no-score");
					if (ratingTab) {
						ratingTab.classList.add("no-score");
					}
					const starsLabel = starsWrapper.querySelector(".stars-label");
					if (starsLabel) {
						starsLabel.textContent = window.NAT.translations("insertFirstReview");
					}
				}
			}
		}

		if (ratingTab) {
			starsWrapper.addEventListener("click", function (event) {
				event.preventDefault();
				window.NAT.utils.scrollToElement(ratingTab);
			});
		}
	}
	if (detailParameters) {
		const parametersInProductTop = document.createElement("div");
		parametersInProductTop.className = "product-parameters-product-top";
		parametersInProductTop.innerHTML = detailParameters.outerHTML;

		const variants = document.querySelector(".p-short-description > .pv-variants");
		if (variants) {
			const parametersColumn = document.createElement("div");
			parametersColumn.className = "product-parameters-column";
			parametersColumn.append(parametersInProductTop, variants);
			infoWrapper.appendChild(parametersColumn);
		} else {
			infoWrapper.appendChild(parametersInProductTop);
		}

		parametersInProductTopTrs = parametersInProductTop.querySelectorAll("tr");

		// For each tr, read the th text; if it equals the "Vhodné pro" (suitable for) label, move it into the vhodne-pro wrapper
		parametersInProductTopTrs.forEach((tr) => {
			const th = tr.querySelector("th");
			if (th && th.textContent.trim() === window.NAT.translations("vhodnePro")) {
				const td = tr.querySelector("td");
				if (td) {
					const vhodneProElement = document.createElement("div");
					vhodneProElement.className = "vhodne-pro-element";

					const thSpan = document.createElement("span");
					// NOTE: this replace() is a no-op (thSpan is empty and gets overwritten on the next line); preserved from old code.
					thSpan.textContent = thSpan.textContent.replace(":", "");
					thSpan.textContent = th.textContent.trim();
					thSpan.className = "vhodne-pro-title";
					vhodneProElement.appendChild(thSpan);

					const entries = td.textContent
						.split(",")
						.map((e) => e.trim())
						.filter((e) => e.length > 0);
					entries.forEach((entry) => {
						const entrySpan = document.createElement("span");
						entrySpan.textContent = entry;
						vhodneProElement.appendChild(entrySpan);
					});

					vhodneProWrapper.appendChild(vhodneProElement);
					vhodneProWrapper.classList.add("active");
					tr.remove(); // Remove the tr element
				}
			}
		});
	}

	const dostupnostADoruceniDoWrapper = document.createElement("div");
	dostupnostADoruceniDoWrapper.className = "dostupnost-doruceni-wrapper";
	const availabilityAndDeliveryWrapper =
		dostupnost?.closest(".availability-and-delivery-wrapper") ||
		document.querySelector(".product-top .availability-and-delivery-wrapper");
	if (availabilityAndDeliveryWrapper) {
		dostupnostADoruceniDoWrapper.appendChild(availabilityAndDeliveryWrapper);
		dostupnostADoruceniDoWrapper.classList.add("active");
	} else if (dostupnost) {
		dostupnostADoruceniDoWrapper.appendChild(dostupnost);
		dostupnostADoruceniDoWrapper.classList.add("active");
	}
	if (dostupnost) {
		const availabilityAmount = dostupnost.querySelector(".availability-amount");
		// if in stock
		if (availabilityAmount) {
			isAvailableProduct = true;
			body.classList.add("product-is-available");
			availabilityAmount.textContent = availabilityAmount.textContent.replace(/[()]/g, "");
			availabilityAmount.textContent = availabilityAmount.textContent.replace(
				">",
				window.NAT.translations("moreThan"),
			);

			if (souvisejiciProdukty) {
				document.querySelector(".p-detail").appendChild(souvisejiciProdukty);

				if (souvisejiciProduktyTitle) {
					souvisejiciProdukty.insertAdjacentElement("beforebegin", souvisejiciProduktyTitle);
				}
			}
		}
		// when out of stock
		if (!availabilityAmount) {
			body.classList.add("product-not-available");
			dostupnostADoruceniDoWrapper.classList.add("not-available");
			if (souvisejiciProdukty) {
				document.querySelector(".p-detail-inner").insertAdjacentElement("afterend", souvisejiciProdukty);

				if (souvisejiciProduktyTitle) {
					souvisejiciProdukty.insertAdjacentElement("beforebegin", souvisejiciProduktyTitle);
				}
			}
		}
	}
	if (shippingOptions) {
		dostupnostADoruceniDoWrapper.appendChild(shippingOptions);
		dostupnostADoruceniDoWrapper.classList.add("active");
	}
	infoWrapper.appendChild(dostupnostADoruceniDoWrapper);
	enhanceDeliveryTooltips(dostupnostADoruceniDoWrapper);

	if (addToCartBtn) {
		priceWrapper.appendChild(addToCartBtn);
	} else {
		// what happens when the product is not for sale
		const notifyMeButtonWrapper = document.createElement("div");
		notifyMeButtonWrapper.classList.add("sold-out-add-to-cart");
		notifyMeButtonWrapper.classList.add("add-to-cart");
		if (watchdog) {
			const notifyMeButton = document.createElement("div");
			notifyMeButton.classList.add("notify-me-button");
			notifyMeButton.classList.add("custom-add-to-cart-button");

			notifyMeButton.textContent = window.NAT.translations("watchDog");

			notifyMeButtonWrapper.appendChild(notifyMeButton);
			notifyMeButton.addEventListener("click", function () {
				watchdog.click();
			});
		} else {
			const emptyDiv = document.createElement("div");
			emptyDiv.className = "empty-div";
			notifyMeButtonWrapper.appendChild(emptyDiv);
		}

		if (souvisejiciProdukty) {
			const showSimiliarProductsButton = document.createElement("div");
			showSimiliarProductsButton.className = "show-similiar-products-button";

			showSimiliarProductsButton.textContent = window.NAT.translations("showRelatedProducts");

			notifyMeButtonWrapper.prepend(showSimiliarProductsButton);
			showSimiliarProductsButton.addEventListener("click", function () {
				window.NAT.utils.scrollToElement(souvisejiciProdukty);
			});
		} else {
			const emptyDiv = document.createElement("div");
			emptyDiv.className = "empty-div";
			notifyMeButtonWrapper.prepend(emptyDiv);
		}

		priceWrapper.appendChild(notifyMeButtonWrapper);
	}

	if (finalProductPrice) {
		const withVATElement = document.createElement("span");
		withVATElement.className = "with-vat";

		withVATElement.textContent = window.NAT.translations("withVAT");

		finalProductPrice.appendChild(withVATElement);
	}

	if (continueReadingShortDescription) {
		const continueReadingShortDescriptionA = continueReadingShortDescription.querySelector("a");
		if (continueReadingShortDescriptionA) {
			continueReadingShortDescriptionA.textContent = window.NAT.translations("readMore");
		}
	}

	if (productsAlternative) {
		const natiosBlockSelector = document.querySelector(".natios-brand-description-block-wrapper");
		if (natiosBlockSelector) {
			natiosBlockSelector.insertAdjacentElement("beforebegin", productsAlternative);
		} else {
			// NOTE: throws if benefitBanner is missing here; preserved from old code.
			benefitBanner.insertAdjacentElement("beforebegin", productsAlternative);
		}
		const productsAlternativeTitle = document.createElement("p");
		productsAlternativeTitle.className = "products-alternative-title";

		productsAlternativeTitle.textContent = window.NAT.translations("productVariants");

		productsAlternative.prepend(productsAlternativeTitle);
		let productsAlternativeItems = productsAlternative.querySelectorAll(".product");
		if (productsAlternativeItems && productsAlternativeItems.length > 0) {
			productsAlternativeItems.forEach((item) => {
				if (!item.querySelector(".availability-amount")) {
					item.remove(); // Remove items without availability amount
				}
			});
		}

		productsAlternativeItems = productsAlternative.querySelectorAll(".product");
		if (!productsAlternativeItems || productsAlternativeItems.length == 0) {
			productsAlternative.remove();
			productsAlternativeTitle.remove();
		}
		if (productsAlternativeItems && productsAlternativeItems.length > 4) {
			productsAlternative.classList.add("multiple-rows-of-alternatives");
			const showMoreAlternativesButton = document.createElement("div");
			showMoreAlternativesButton.className = "show-more-alternatives-button";

			showMoreAlternativesButton.textContent = window.NAT.translations("showMoreVariants");

			productsAlternative.appendChild(showMoreAlternativesButton);
			showMoreAlternativesButton.addEventListener("click", function () {
				productsAlternative.classList.add("active-all");
			});
		}
	}

	if (ratingTab) {
		const ratingTabTitleElement = document.createElement("h3");
		ratingTabTitleElement.textContent = window.NAT.translations("reviewsTitle");
		const rateAverageWrap = ratingTab.querySelector(".rate-average-wrap");
		if (rateAverageWrap) {
			rateAverageWrap.prepend(ratingTabTitleElement);
		}
	}

	if (relatedFiles) {
		const natiosAnalysis = document.querySelector(".product-widgets .natios-analysis .natios-analysis-content-left");
		if (natiosAnalysis) {
			const allHrefsInRelatedFiles = relatedFiles.querySelectorAll("a:not(.btn)");
			if (allHrefsInRelatedFiles && allHrefsInRelatedFiles.length > 0) {
				allHrefsInRelatedFiles.forEach((a) => {
					// Remove any text in parentheses with "kB" or "MB" etc.
					a.textContent = a.textContent.replace(/\(\s*[\d.,]+\s*[kMGT]?B\s*\)/gi, "").trim();
				});
			}
			natiosAnalysis.appendChild(relatedFiles);
			const showTestsButton = natiosAnalysis.querySelector(".show-tests-button");
			if (showTestsButton) {
				showTestsButton.remove();
			}
		} else {
			const basicDescription = document.querySelector("#description .basic-description");
			if (basicDescription) {
				basicDescription.insertAdjacentElement("afterend", relatedFiles);
			}
		}
	}

	if (extendedDescription) {
		if (tabContent) {
			tabContent.appendChild(extendedDescription);
		}
	}

	const imageElement = document.querySelector(".p-image-wrapper .p-image");
	const flagsWrapper = document.querySelector(".product-top .flags.flags-default");

	if (imageElement && flagsWrapper) {
		imageElement.appendChild(flagsWrapper);
	}

	// measure units in product detail
	try {
		measureUnitFromFiltersDetail();
	} catch (error) {
		console.error("Error in measureUnitFromFiltersDetail:", error);
	}

	if (!loadNextRatings && productVotesWraps && productVotesWraps.length > 0) {
		let isAnyWrapHidden = false;
		//if any wrap has display none (not inline)
		productVotesWraps.forEach((wrap) => {
			if (getComputedStyle(wrap).display === "none") {
				isAnyWrapHidden = true;
			}
		});
		if (isAnyWrapHidden) {
			const customListingControls = document.createElement("div");
			customListingControls.className = "listingControls";
			customListingControls.setAttribute("aria-labelledby", "listingControlsHeadingRatings");

			const customLoadMore = document.createElement("div");
			customLoadMore.className = "loadMore";
			customLoadMore.setAttribute("data-context", "ratings");

			const customLoadMoreButton = document.createElement("button");
			customLoadMoreButton.classList.add(
				"loadMore__button",
				"loadMore__button--ratings",
				"btn",
				"btn-secondary",
				"js-loadMore__button--ratings",
			);
			customLoadMoreButton.type = "button";
			customLoadMoreButton.setAttribute("aria-controls", "ratingsList");
			customLoadMoreButton.textContent = window.NAT.translations("showNext");

			customLoadMore.appendChild(customLoadMoreButton);
			customListingControls.appendChild(customLoadMore);

			productVotesWraps[0].parentElement.parentElement.appendChild(customListingControls);

			customLoadMoreButton.addEventListener("click", function (e) {
				if (ratingTab) {
					ratingTab.classList.add("all-visible");
					customListingControls.style.display = "none";
				}
			});
		}
	}

	if (loadNextRatings) {
		loadNextRatings.addEventListener("click", function (e) {
			if (ratingTab) {
				ratingTab.classList.add("all-visible");
			}
		});
	}

	enhanceQuantityDiscounts();

	// Add sticky sell section — must be the very last step
	if (longDescription) {
		const stickySell = document.createElement("div");
		stickySell.className = "sticky-sell";

		const stickySellText = document.createElement("span");
		stickySellText.className = "sticky-sell-text";
		stickySellText.innerHTML = productName ? productName.innerHTML : "";
		stickySell.appendChild(stickySellText);

		const stickySellRatingsWrapper = document.createElement("div");
		stickySellRatingsWrapper.className = "sticky-sell-ratings-wrapper";
		if (starsWrapper) {
			stickySellRatingsWrapper.innerHTML = starsWrapper.outerHTML;
		}
		stickySellRatingsWrapper.addEventListener("click", function (event) {
			event.preventDefault();
			const ratingTab = document.querySelector("#ratingTab");
			if (ratingTab) {
				window.NAT.utils.scrollToElement(ratingTab);
			}
		});
		stickySell.appendChild(stickySellRatingsWrapper);

		const stickySellAvailability = document.createElement("div");
		stickySellAvailability.className = "sticky-sell-availability";
		const editedDostupnost = document.querySelector(".product-top .dostupnost-doruceni-wrapper");

		if (editedDostupnost) {
			stickySellAvailability.innerHTML = editedDostupnost.outerHTML;
		}
		stickySell.appendChild(stickySellAvailability);

		const stickyPriceAndButton = document.createElement("div");
		stickyPriceAndButton.className = "sticky-price-and-button";
		const editedPriceWrapper = document.querySelector(".product-top .p-final-price-wrapper");

		if (editedPriceWrapper) {
			stickyPriceAndButton.innerHTML = editedPriceWrapper.outerHTML;
		}
		stickySell.appendChild(stickyPriceAndButton);
		longDescription.appendChild(stickySell);

		const stickySellButton = document.querySelector(".sticky-sell .p-final-price-wrapper .add-to-cart-button");
		const productTopSellButton = document.querySelector(".product-top .p-final-price-wrapper .add-to-cart-button");
		if (stickySellButton) {
			stickySellButton.addEventListener("click", function (event) {
				event.preventDefault();
				productTopSellButton.click();
			});
		}

		const stickySellInput = document.querySelector(".sticky-sell input.amount");
		const productTopInput = document.querySelector(".product-top input.amount");
		const productStickySimiliar = document.querySelector(".sticky-sell .show-similiar-products-button");
		if (stickySellInput && productTopInput) {
			let isProgrammaticChange = false;

			stickySellInput.addEventListener("change", function () {
				if (isProgrammaticChange) {
					isProgrammaticChange = false; // Reset the flag
					return;
				}
				isProgrammaticChange = true; // Set the flag before triggering the other input
				productTopInput.value = stickySellInput.value;
				productTopInput.dispatchEvent(new Event("change")); // Trigger the change event if needed
			});

			productTopInput.addEventListener("change", function () {
				if (isProgrammaticChange) {
					isProgrammaticChange = false; // Reset the flag
					return;
				}
				isProgrammaticChange = true; // Set the flag before triggering the other input
				stickySellInput.value = productTopInput.value;
				stickySellInput.dispatchEvent(new Event("change")); // Trigger the change event if needed
			});
		}
		if (productStickySimiliar && souvisejiciProdukty) {
			productStickySimiliar.addEventListener("click", function () {
				window.NAT.utils.scrollToElement(souvisejiciProdukty);
			});
		}
	}

	bindDeliveryTooltipInteractions();
}

function measureUnitFromFiltersDetail() {
	const product = document.querySelector(".product-top");

	if (product.classList.contains("product-edited-measure")) {
		return; // Skip if already processed
	}
	// NOTE: async util fired without await (as in the old code) — the read of
	// window.NAT.measureFiltersData below may see stale/empty data on the first uncached load.
	window.NAT.utils.downloadAndSaveMeasureUnitFilter();
	product.classList.add("product-edited-measure");

	const productFilterData = window.NAT.measureFiltersData;
	if (!productFilterData || productFilterData.length === 0) {
		return; // No filter data available
	}

	if (!productCodeValue) {
		console.warn("Product code not found for a product.");
		return;
	}

	const amountText = productFilterData.find((item) => item.code === productCodeValue)?.value;
	if (!amountText) {
		console.warn("No measure unit found for product code:", productCodeValue);
		return;
	}

	const normalizedAmountText = amountText.replace(",", ".").trim();

	// Extract the numeric part (including decimal)
	const productMeasureAmount = normalizedAmountText.match(/[\d.]+/) ? normalizedAmountText.match(/[\d.]+/)[0] : "";

	// Extract the unit part (letters and spaces after the number)
	const productMeasureUnit = normalizedAmountText.replace(/[\d.\s]+/, "").trim();

	const priceFinalWrapper = product.querySelector(".p-final-price-wrapper");

	const pricePerUnitDiv = document.createElement("div");
	pricePerUnitDiv.className = "product-price-per-unit-detail";
	const priceFinal = product.querySelector(".price-final");
	let priceFinalValue;

	if (priceFinal) {
		// Extract the text content, trim it, and remove everything but numbers
		priceFinalValue = priceFinal.textContent.trim().replace(/[^\d.,]/g, ""); // Keep only digits, commas, and dots
		priceFinalValue = parseFloat(priceFinalValue.replace(",", ".")).toFixed(2);
	}

	let singleMeasuringUnit = {};
	if (window.NAT.lang === "cs") {
		singleMeasuringUnit = {
			kapslí: "kapsle",
			tablet: "tableta",
			tobolek: "tobolka",
			tabletek: "tabletka",
			dávek: "dávka",
			dávky: "dávka",
			produkty: "produkt",
			produktů: "produkt",
		};
	}
	if (window.NAT.lang === "sk") {
		singleMeasuringUnit = {
			kapsúl: "kapsula",
			kapsula: "kapsula",
			tabliet: "tableta",
			tablietek: "tabletka",
			dávok: "dávka",
			dávky: "dávka",
			produktov: "produkt",
			produkty: "produkt",
		};
	}
	if (window.NAT.lang === "pl") {
		singleMeasuringUnit = {
			kapsułek: "kapsułka",
			kapsułki: "kapsułka",
			tabletek: "tableta",
			saszetek: "saszetka",
			pastylek: "pastylka",
			gumisiów: "gumiś",
			dawek: "dawka",
			produktów: "produkt",
			produkty: "produkt",
		};
	}

	let pricePerUnit_Unit;

	let foundUnitMatch = false;

	// Iterate over the keys in the object
	for (let key in singleMeasuringUnit) {
		if (productMeasureUnit.includes(key)) {
			foundUnitMatch = true;
			pricePerUnit_Unit = singleMeasuringUnit[key];
			break; // Exit the loop once a match is found
		}
	}
	if (!foundUnitMatch) {
		// If no match is found, use the original measure unit
		pricePerUnit_Unit = productMeasureUnit;
	}

	const pricePerUnit_Value = priceFinalValue / productMeasureAmount;

	const pricePerUnit_ValueSpan = document.createElement("span");
	pricePerUnit_ValueSpan.className = "product-price-per-unit-value-detail";

	if (window.NAT.lang === "cs") {
		pricePerUnit_ValueSpan.textContent =
			pricePerUnit_Value.toFixed(2).replace(".", ",") + " Kč / 1 " + pricePerUnit_Unit;
	}
	if (window.NAT.lang === "sk") {
		pricePerUnit_ValueSpan.textContent =
			pricePerUnit_Value.toFixed(2).replace(".", ",") + " € / 1 " + pricePerUnit_Unit;
	}
	if (window.NAT.lang === "pl") {
		pricePerUnit_ValueSpan.textContent =
			pricePerUnit_Value.toFixed(2).replace(".", ",") + " zł / 1 " + pricePerUnit_Unit;
	}

	priceFinalWrapper.appendChild(pricePerUnitDiv);
	pricePerUnitDiv.appendChild(pricePerUnit_ValueSpan);
}

function productThumbnailInNavigation() {
	const navigaceProduktu = document.querySelector(".shp-tabs-row");
	const productMainImage = document.querySelector(".p-image-wrapper .p-main-image");
	const productName = document.querySelector("h1");
	const productPrice = document.querySelector(".product-top .price-final");

	if (!navigaceProduktu || !productMainImage || !productName || !productPrice) {
		console.warn("Product main image, name, or price not found.");
		return; // Exit if any of the elements are not found
	}

	const productThumbnailButton = document.createElement("div");

	if (isAvailableProduct) {
		productThumbnailButton.className = "product-thumbnail-add-to-cart-button";
		productThumbnailButton.textContent = window.NAT.translations("toCart");
	}

	if (!isAvailableProduct) {
		productThumbnailButton.className = "product-thumbnail-notice-me-button";
		productThumbnailButton.textContent = window.NAT.translations("alertMe");
	}

	const productThumbnail = document.createElement("div");
	productThumbnail.className = "product-thumbnail";

	productThumbnail.innerHTML = `
		<div class="product-thumbnail-image-wrapper">
			${productMainImage.innerHTML}
		</div>
		<div class="product-thumbnail-info-wrapper">
			<div class="product-thumbnail-name">
				${productName.innerHTML}
			</div>
			<div class="product-thumbnail-price-button-wrapper">
				<div class="product-thumbnail-price">
					${productPrice.innerHTML}
					</div>
				<div class="product-thumbnail-buttons">
					${productThumbnailButton.outerHTML}
				</div>
			</div>
		</div>
	`;

	navigaceProduktu.prepend(productThumbnail);
	if (isAvailableProduct) {
		document.querySelector(".product-thumbnail-add-to-cart-button").addEventListener("click", function () {
			shoptet.cartShared.addToCart({ productCode: productCodeValue });
		});
	}
	if (!isAvailableProduct) {
		if (watchdog) {
			document.querySelector(".product-thumbnail-notice-me-button").addEventListener("click", function () {
				watchdog.click();
			});
		}
	}
}

function productNavigationCustom() {
	const detailTabs = document.querySelector("#p-detail-tabs");
	if (!detailTabs) {
		return; // Exit if detail tabs are not found
	}
	const shpTabs = document.querySelectorAll(".shp-tab");
	if (shpTabs && shpTabs.length > 0) {
		shpTabs.forEach((tab) => {
			tab.remove();
		});
	}

	const filesButtonDesc = document.querySelector("#show-tests-button");

	if (relatedFiles) {
		const filesTabTitleElement = document.createElement("h3");
		filesTabTitleElement.textContent = window.NAT.translations("relatedFilesTitle");
		relatedFiles.prepend(filesTabTitleElement);

		const productFiles = relatedFiles.querySelectorAll("li");
		if (productFiles && productFiles.length > 0) {
			productFiles.forEach((file) => {
				const fileHref = file.querySelector("a").href;
				const fileType = fileHref.split(".").pop().toUpperCase();
				const showFileBtn = document.createElement("a");
				showFileBtn.href = fileHref;
				showFileBtn.classList.add("btn", "show-file");
				showFileBtn.setAttribute("target", "_blank");

				if (document.querySelector(".natios-analysis")) {
					showFileBtn.textContent = window.NAT.translations("showCertificate");
				} else {
					showFileBtn.textContent = window.NAT.translations("show");
				}

				const fileTypeSpan = document.createElement("span");
				fileTypeSpan.className = "file-type";
				fileTypeSpan.textContent = "(" + fileType + ")";
				showFileBtn.appendChild(fileTypeSpan);
				file.appendChild(showFileBtn);
			});
		}
		if (filesButtonDesc) {
			filesButtonDesc.addEventListener("click", function (event) {
				event.preventDefault();
				window.NAT.utils.scrollToElement(relatedFiles);
			});
		}
	}

	if (detailTabs) {
		createTabForSection(
			"#product-set",
			window.NAT.translations("productSetTitle"),
			true,
			detailTabs,
		);

		createTabForSection("#description", window.NAT.translations("descriptionTitle"), true, detailTabs);

		createTabForSection(
			".product-widget[widget-type='directions']",
			window.NAT.translations("directionsTitle"),
			false,
			detailTabs,
		);

		createTabForSection(
			".product-widget[widget-type='ingredients']",
			window.NAT.translations("ingredientsTitle"),
			false,
			detailTabs,
		);
		createTabForSection("table.ingredients", window.NAT.translations("ingredientsTitle"), true, detailTabs);

		createTabForSection(".natios-analysis", window.NAT.translations("certificatesTitle"), true, detailTabs);
		createTabForSection("#ratingTab", window.NAT.translations("reviewsTitle"), false, detailTabs);
		createTabForSection(".natios-support-wrapper", window.NAT.translations("weSupportTitle"), false, detailTabs);
		createTabForSection(".products-related", window.NAT.translations("relatedProductsTitle"), false, detailTabs);
	}

	function createTabForSection(sectionId, tabTitle, isHardcoded, detailTabs) {
		const section = document.querySelector(sectionId);
		if (!section) {
			return;
		}

		const tab = document.createElement("li");
		tab.className = "shp-tab";

		let tabTitleText = tabTitle;

		if (!isHardcoded) {
			tabTitleText = section.querySelector("h2")
				? section.querySelector("h2").textContent.trim()
				: section.querySelector("h3")
					? section.querySelector("h3").textContent.trim()
					: section.querySelector("h4")
						? section.querySelector("h4").textContent.trim()
						: tabTitle;
		}

		tab.innerHTML = `<span class="shp-tab-link" data-tab="${sectionId}">${tabTitleText}</span>`;

		if (sectionId === "#ratingTab") {
			try {
				const numberOfReviews = section.querySelector(".stars-label").textContent.trim().match(/^\d+/)?.[0];
				tab.innerHTML = `<span class="shp-tab-link" data-tab="${sectionId}">${tabTitleText}<span class="number-of-reviews">${numberOfReviews}</span></span>`;
			} catch (error) {
				console.warn("Error parsing number of reviews:", error);
			}
		}
		detailTabs.appendChild(tab);

		tab.addEventListener("click", function () {
			const activeShopTab = document.querySelector(".shp-tab.active");
			if (activeShopTab && activeShopTab !== tab) {
				activeShopTab.classList.remove("active");
			}
			window.NAT.utils.scrollToElement(section);
		});

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						const activeShopTab = document.querySelector(".shp-tab.active");
						if (activeShopTab) {
							activeShopTab.classList.remove("active");
						}
						tab.classList.add("active");
					}
				});
			},
			{ root: null, threshold: 0.01 }, // Trigger when 1% of the section is visible
		);
		observer.observe(section);
	}
}

function makeCarouselFromImages() {
	const productTopImage = document.querySelector(".product-top .p-image-wrapper .p-main-image");
	if (!productTopImage) {
		return;
	}

	//wrap productTopImage in image-carousel-wrapper
	const imageCarouselWrapper = document.createElement("div");
	imageCarouselWrapper.classList.add("image-carousel-wrapper");
	productTopImage.parentNode.insertBefore(imageCarouselWrapper, productTopImage);
	imageCarouselWrapper.appendChild(productTopImage);

	const allImagesInThumbnails = document.querySelectorAll(".p-thumbnails-inner .p-thumbnail");
	if (!allImagesInThumbnails || allImagesInThumbnails.length === 0 || allImagesInThumbnails.length === 1) {
		return;
	}
	let imageIndex = 0;
	allImagesInThumbnails.forEach((thumbnail, index) => {
		if (index !== 0) {
			const thumbnailClone = thumbnail.cloneNode(true);
			const thumbnailHref = thumbnailClone.getAttribute("href");
			const thumbnailImage = thumbnailClone.querySelector("img");

			if (thumbnailImage) {
				thumbnailImage.setAttribute("src", thumbnailHref);
				thumbnailImage.setAttribute("data-src", thumbnailHref);
				thumbnailImage.setAttribute("width", 1024);
				thumbnailImage.setAttribute("height", 768);
			}
			thumbnailClone.classList.add("p-main-image");
			thumbnailClone.classList.add("no-first-image");

			thumbnailClone.classList.remove("p-thumbnail");
			imageCarouselWrapper.appendChild(thumbnailClone);
		}
		thumbnail.removeAttribute("href");

		thumbnail.addEventListener("click", function (event) {
			event.preventDefault();
			imageIndex = index;
			transformTopImage();
			const activeThumbnail = document.querySelector(".p-thumbnails-inner .p-thumbnail.active");
			if (activeThumbnail) {
				activeThumbnail.classList.remove("active");
			}
			thumbnail.classList.add("active");
		});
	});

	const imagesWrapper = document.querySelector(".p-image-wrapper .p-image");
	const allImagesInCarousel = imageCarouselWrapper.querySelectorAll(".p-main-image");

	window.NAT.utils.inicializeSliderElementSnap(
		imagesWrapper,
		imageCarouselWrapper,
		allImagesInCarousel,
		"main-images-slider",
		"img",
		true,
	);

	changeActiveThumbnail();

	let thumbnailDebounce;
	imageCarouselWrapper.addEventListener("scroll", function () {
		const imageWidth = allImagesInCarousel[0].clientWidth;
		imageIndex = Math.round(imageCarouselWrapper.scrollLeft / imageWidth);
		clearTimeout(thumbnailDebounce);
		thumbnailDebounce = setTimeout(changeActiveThumbnail, 80);
	});

	function transformTopImage() {
		if (!allImagesInCarousel) return;

		const imageWidth = allImagesInCarousel[0].clientWidth;
		imageCarouselWrapper.scrollTo({
			left: imageIndex * imageWidth,
			behavior: "smooth",
		});
	}
	function changeActiveThumbnail() {
		allImagesInThumbnails.forEach((thumbnail, thumbnailIndex) => {
			if (thumbnailIndex === imageIndex) {
				thumbnail.classList.add("active");
			} else {
				thumbnail.classList.remove("active");
			}
		});
	}
}

function addLaboratoryAnalysisToTop() {
	const natiosAnalysis = document.querySelector(".natios-analysis");
	if (natiosAnalysis) {
		const shortBenefitsWrapper = document.querySelector(".product-top .short-benefits-wrapper ul");
		if (shortBenefitsWrapper) {
			const laboratoryAnalysisElement = document.createElement("li");
			laboratoryAnalysisElement.classList.add("laboratory-analysis-element");
			laboratoryAnalysisElement.setAttribute("tabindex", "0");

			laboratoryAnalysisElement.textContent = window.NAT.translations("laboratoryAnalysisText");

			shortBenefitsWrapper.appendChild(laboratoryAnalysisElement);
			laboratoryAnalysisElement.addEventListener("click", function () {
				window.NAT.utils.scrollToElement(natiosAnalysis);
			});
		}
	}
}

function analysisTableExplanation() {
	const analysisContentRight = document.querySelector(".natios-analysis-content-right");
	if (!analysisContentRight) return;

	analysisContentRight.classList.add("test-element");

	let currentUl = null;
	let currentActiveFourthTd = null;

	// 1) Global clearer: runs BEFORE bubbling handlers (capture phase)
	document.addEventListener(
		"click",
		(e) => {
			if (currentUl) {
				const clickedInsideUl = currentUl.contains(e.target);
				const td = e.target.closest("td");
				const insideanalysisContentRight = analysisContentRight.contains(e.target);
				const isFourthTd = !!td && td.cellIndex === 3;
				const isFifthTd = !!td && td.cellIndex === 4;

				// keep open if clicking the floating UL itself
				if (clickedInsideUl) return;
				// let the container handler manage clicks on a 4th td
				if (insideanalysisContentRight && isFourthTd) return;
				// ignore clicks on a 5th td inside the container
				if (insideanalysisContentRight && isFifthTd) return;

				// Otherwise remove currentUl and clear active state
				currentUl.remove();
				currentUl = null;
				if (currentActiveFourthTd) {
					currentActiveFourthTd.classList.remove("active");
					currentActiveFourthTd = null;
				}
			}
		},
		true,
	);

	// 2) Inside-container logic: activate the 5th td's UL when 4th td is clicked
	analysisContentRight.addEventListener("click", (e) => {
		const td = e.target.closest("td");
		if (!td || !analysisContentRight.contains(td)) return;

		const isFourthTd = td.cellIndex === 3; // zero-based
		if (isFourthTd) {
			// Toggle behavior: if clicking the same active 4th td, close it
			if (currentActiveFourthTd === td) {
				if (currentUl) {
					currentUl.remove();
					currentUl = null;
				}
				td.classList.remove("active");
				currentActiveFourthTd = null;
				return;
			}

			// Clear any existing open UL and active 4th td
			if (currentUl) {
				currentUl.remove();
				currentUl = null;
			}
			if (currentActiveFourthTd) {
				currentActiveFourthTd.classList.remove("active");
				currentActiveFourthTd = null;
			}

			const fifthTd = td.parentElement.querySelector("td:nth-child(5)");
			if (!fifthTd) return;

			const ul = fifthTd.querySelector("ul");
			if (!ul) return;

			// clone and append the ul to body
			currentUl = ul.cloneNode(true);
			currentUl.style.position = "absolute";
			currentUl.classList.add("active-table-explanation");

			// position it relative to the 4th td clicked
			const rect = td.getBoundingClientRect();
			currentUl.style.top = rect.bottom + window.scrollY - rect.height - 5 + "px";
			currentUl.style.right = window.innerWidth - rect.right - window.scrollX + "px";

			document.body.appendChild(currentUl);

			// mark the 4th td as active
			td.classList.add("active");
			currentActiveFourthTd = td;
		}
	});
}

function addDenDetiTextToShortDescription() {
	if (!shortDescription) return;
	const denDetiFlag = document.querySelector(".product-top .flag-dendeti10");
	if (!denDetiFlag) return;
	const denDetiDiv = document.createElement("div");
	denDetiDiv.className = "den-deti-text";
	const denDetiText = document.createElement("p");
	denDetiText.innerHTML = window.NAT.translations("denDetiKupon");
	denDetiDiv.appendChild(denDetiText);
	shortDescription.appendChild(denDetiDiv);
}

function inicializeReviewFromEmail() {
	if (window.location.hash !== "#ratingTab") return;

	const params = new URLSearchParams(window.location.search);
	const name = params.get("name");

	const trigger = document.querySelector("#ratingTab .rate-form-trigger");
	if (trigger) trigger.click();

	if (name) {
		const nameInput = document.querySelector('#ratingTab input[name="fullName"]');
		if (nameInput) nameInput.value = name;
	}
}

function editDeliveryPricesPopup() {
	let lastShippingCheck = Date.now();
	const observerShippingOptions = new MutationObserver((mutationsList, observer) => {
		for (const mutation of mutationsList) {
			if (mutation.type === "childList") {
				const shippingOptionsPopup = document.querySelector(".shipping-options-popup");
				const now = Date.now();

				if (shippingOptionsPopup) {
					if (now - lastShippingCheck < 1000) {
						return; // Skip if the last check was less than 1 second ago
					}
					lastShippingCheck = now;

					changePricesInShippingTooltip();
				}
			}
		}
	});

	observerShippingOptions.observe(document.body, { childList: true, subtree: true });

	function changePricesInShippingTooltip() {
		const shippingOptionsPopup = document.querySelector(".shipping-options-popup");
		if (!shippingOptionsPopup) return;
		const priceRange = shippingOptionsPopup.querySelector(".price-range");
		if (!priceRange) return;

		let shippingPrices = {};
		if (window.NAT.lang === "cs") {
			shippingPrices = {
				"Zásilkovna (Odběrné místo)": "49 Kč",
				"Balíkovna - ČP (Výdejní místa)": "49 Kč",
				"DPD (Pick Up) - Výdejní místa": "49 Kč",
				"DPD (Doručení na adresu)": "79 Kč",
				"Balíkovna na adresu - ČP": "85 Kč",
				"Zásilkovna (Doručení na adresu)": "89 Kč",
			};
		}
		if (window.NAT.lang === "sk") {
			shippingPrices = {
				"Zásilkovna Z-point (odberné miesto)": "€3,20",
				"Slovenská pošta – Balík na poštu": "€2,80",
				"Slovenská pošta – Balík do BalíkoBOXU": "€2,80",
				"Slovenská pošta – Kuriér na adresu": "€3,30",
				"DPD (doručenie na adresu)": "€4,20",
				"Zásielkovňa (doručenie na adresu)": "€4,50",
			};
		}
		if (window.NAT.lang === "pl") {
			shippingPrices = {
				"UPS - Kurier na adres następnego dnia roboczego": "18 zł",
				"Inpost - Kurier na adres": "15 zł",
				"Inpost - Paczkomaty 24/7": "13 zł",
			};
		}

		document.querySelectorAll(".shipping-billing-name").forEach((nameEl) => {
			const name = nameEl.textContent.trim().replace(/\s+/g, " ");
			const price = shippingPrices[name];
			if (price) {
				const priceEl = nameEl.closest(".shipping-row")?.querySelector(".payment-shipping-price");
				if (priceEl) {
					priceEl.textContent = price;
					priceEl.classList.remove("for-free");
				}
			}
		});
	}
}
